const translations = {
  Index: 'L.p.',
  InvoiceNo: 'Nr faktury',
  CorrectedInvoiceNo: 'Nr faktury korygowanej',
  InvoiceDate: 'Data faktury',
  NseiStatus: 'KSeF',
  Source: 'Źródło',
  GrossValue: 'Brutto [PLN]',
  NetValue: 'Netto [PLN]',
  TaxValue: 'VAT [PLN]',
  Today: 'Dziś',
  Last7: 'Ostatnie 7 dni',
  Last30: 'Ostatnie 30 dni',
  Last90: 'Ostatnie 90 dni',
  FromDate: 'Od daty',
  ToDate: 'Do daty',
  Refresh: 'Odśwież',
  RefreshBy: 'Odśwież wg zadanego zakresu dat',
  OrderBy: 'Sortuj według',
  InvoiceDateAsc: 'Data faktury rosnąco',
  InvoiceDateDesc: 'Data faktury malejąco',
  InvoiceNoAsc: 'Numer faktury rosnąco',
  InvoiceNoDesc: 'Numer faktury malejąco',
  GrossValueAsc: 'Wartość brutto rosnąco',
  GrossValueDesc: 'Wartość brutto malejąco',
  TaxValueAsc: 'Wartość VAT rosnąco',
  TaxValueDesc: 'Wartość VAT malejąco',
  DownloadSelectedInvoice: 'Pobierz wybraną fakturę',
  DownloadInvoicesReport: 'Pobierz zestawienie faktur',
  NSEI: 'KSeF',
  Report: 'Raport',
  Show: 'Pokaż',
  Summary: 'Razem [PLN]:',
  GrossSummary: 'brutto:',
  NetSummary: 'netto:',
  TaxSummary: 'vat:',
  Range: 'Zakres dat',
  ContractorName: 'Nabywca',
  SummaryInfoPrefix: 'Podsumowanie zawiera sumę wszystkich',
  SummaryInfoPostfix: 'rekordów',
  Filters: 'Filtry',
  ApplyFilters: 'Zastosuj filtry',
  ClearFilters: 'Wyczyść filtry',
  CurrentWeek: 'Bieżący tydzień',
  CurrentMonth: 'Bieżący miesiąc',
  PreviousMonth: 'Poprzedni miesiąc',
  DeleteLast: 'Usuń ostatnią',
  DeleteLastTooltip: 'Usuń z systemu ostatnią fakturę',
  Correction: 'Korekta',
  CorrectionTooltip: 'Wystaw korektę faktury',
  CorrectionInvoiceTitle: 'Korekta faktury {{invoiceNo}}',
  CorrectionCancel: 'Anuluj',
  CorrectionSaveChanges: 'Zapisz zmiany',
  CorrectionReason: 'Przyczyna korekty',
  CorrectionBuyer: 'Nabywca',
  CorrectionAmountSection: 'Kwota, forma płatności, opis',
  CorrectionWas: 'Było',
  CorrectionIs: 'Jest',
  NSEILighthouseStatusTitle: 'Status KSeF',
  NSEILighthouseStatusAvailable: 'DOSTĘPNY',
  NSEILighthouseStatusMaintenance: 'W TRAKCIE KONSERWACJI',
  NSEILighthouseStatusFailure: 'AWARIA',
  NSEILighthouseStatusTotalFailure: 'AWARIA CAŁKOWITA',
  InvoiceInNSEISucceed: 'Faktura',
  InvoiceInNSEISucceedTitle: 'Faktura {{invoiceNo}} jest w KSeF',
  InvoiceInNSEIDescription:
    'Faktura została wysłana do KSeF. Możesz ją zweryfikować skanując kod QR. Możesz również zweryfikować wystawcę skanując kod QR certyfikatu.',
  QRCodeVerification: 'WERYFIKACJA FAKTURY',
  QRCodeCertificate: 'CERTYFIKAT',
  QRCodeClickHint: 'Nie możesz zeskanować kodu? Kliknij go',
  InvoiceInNSEIError: 'Problem z wysłaniem faktury',
  InvoiceInNSEIErrorTitle: 'Problem z wysłaniem faktury {{invoiceNo}} do KSeF',
  InvoiceInNSEIDescriptionError: 'Wystąpił błąd podczas wysyłania faktury do KSeF. Spróbuj ponownie później.',
  InvoiceInNSEIInfo: 'Faktura',
  InvoiceInNSEIInfoTitle: 'Faktura {{invoiceNo}} nie została wysłana do KSeF',
  InvoiceInNSEIDescriptionInfo:
    'Faktura nie została wysłana do KSeF. Możesz wysłać ją ręcznie klikając przycisk poniżej.',
  NSEISend: 'Wyślij do KSeF',
  NSEIError: 'Błąd KSeF',
  InvoiceInNSEIDescriptionProxyError: 'Podczas komunikacji z Serwisem Proxy KSeF wystąpił błąd.',
  NSEIUpo: 'Pobierz UPO',
  NSEIInvoice: 'Pobierz fakturę',
  NSEISendAgain: 'Wyślij do KSeF ponownie',
  NSEIRefreshStatus: 'Odśwież status KSeF',
  CorrectionNSEIBlockedTitle: 'Nie można wysłać korekty do KSeF',
  CorrectionNSEIBlockedDescription:
    'Fakturę korygującą można wysłać do KSeF tylko jeśli faktura korygowana {{correctedInvoiceNo}} jest już zarejestrowana w KSeF.',
  InvoiceId: 'Id',
  ContractorId: 'Id nabywcy',
  SendByEmail: 'Wyślij e-mailem',
};

export default translations;
